import { render, staticRenderFns } from "./salesScope.vue?vue&type=template&id=787ab84c&scoped=true"
import script from "./salesScope.vue?vue&type=script&lang=js"
export * from "./salesScope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787ab84c",
  null
  
)

export default component.exports